import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d1a7772"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "context d-flex flex-column justify-content-center text-light" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<p class=\"d-flex align-items-center justify-content-center\" data-v-5d1a7772><span class=\"material-icons-outlined\" data-v-5d1a7772>timer</span>：設定定時拍照 </p><p class=\"d-flex align-items-center justify-content-center\" data-v-5d1a7772><span class=\"material-icons-outlined\" data-v-5d1a7772>photo_camera</span>：拍攝一張照片 </p><p class=\"d-flex align-items-center justify-content-center\" data-v-5d1a7772><span class=\"material-icons-outlined\" data-v-5d1a7772>folder</span>：設定雲端資料夾 </p>", 3)
const _hoisted_6 = [
  _hoisted_3
]
const _hoisted_7 = { class: "context" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "placeholder-glow h-100" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "placeholder bg-light w-100" })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "context" }
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_6, 512), [
      [_vShow, !_ctx.imageUrl && !_ctx.props.loading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, _hoisted_9, 512), [
      [_vShow, _ctx.props.loading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createElementVNode("figure", null, [
        _createElementVNode("img", {
          src: _ctx.props.imageUrl
        }, null, 8, _hoisted_11)
      ])
    ], 512), [
      [_vShow, _ctx.imageUrl && !_ctx.props.loading]
    ])
  ]))
}